module.exports = __webpack_public_path__ + "img/yijieshu.ec0fbc31.png";